/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/attach': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" _fill="#444" d="M8.5 23.1c-1.9 0-3.8-.7-5.3-2.2C1.8 19.5 1 17.6 1 15.6s.8-3.9 2.2-5.3L11 2.5c2.1-2.1 5.6-2.1 7.8 0s2.1 5.6 0 7.8l-7.1 7.1c-1.4 1.4-3.6 1.4-5 0s-1.4-3.6 0-5l6-6c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-6 6c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l7.1-7.1c.7-.7 1-1.5 1-2.5 0-.9-.4-1.8-1-2.5-1.4-1.4-3.6-1.4-4.9 0l-7.8 7.8c-1 1-1.6 2.4-1.6 3.9s.6 2.8 1.6 3.9c2.1 2.1 5.6 2.1 7.8 0l8.8-8.8c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-8.8 8.8c-1.4 1.6-3.3 2.3-5.3 2.3z"/>'
  }
})
